import { render, staticRenderFns } from "./textlist_2_2.vue?vue&type=template&id=c364006a&scoped=true"
import script from "./textlist_2_2.vue?vue&type=script&lang=js"
export * from "./textlist_2_2.vue?vue&type=script&lang=js"
import style0 from "./textlist_2_2.vue?vue&type=style&index=0&id=c364006a&prod&scoped=true&lang=scss"
import style1 from "./textlist_2_2.vue?vue&type=style&index=1&id=c364006a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c364006a",
  null
  
)

export default component.exports